// Heure limite d'expédition : « Commandez dans 2 h 13 min : expédié aujourd'hui », sinon le prochain jour d'expédition.
// Expédition du lundi au vendredi, hors jours fériés français (calculés) et hors jours de fermeture
// saisis dans les réglages du thème (data-jours-fermes : AAAA-MM-JJ séparés par des virgules).
(() => {
  const JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  const MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  const cle = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  const ajout = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };

  // Dimanche de Pâques (algorithme de Meeus/Jones/Butcher)
  const paques = (a) => {
    const b = a % 19, c = Math.floor(a / 100), d = a % 100, e = Math.floor(c / 4), f = c % 4;
    const g = Math.floor((c + 8) / 25), h = Math.floor((c - g + 1) / 3);
    const i = (19 * b + c - e - h + 15) % 30, k = Math.floor(d / 4), l = d % 4;
    const m = (32 + 2 * f + 2 * k - i - l) % 7, n = Math.floor((b + 11 * i + 22 * m) / 451);
    const mois = Math.floor((i + m - 7 * n + 114) / 31), jour = ((i + m - 7 * n + 114) % 31) + 1;
    return new Date(a, mois - 1, jour);
  };

  const feries = (a) => {
    const p = paques(a);
    return new Set([
      `${a}-01-01`, `${a}-05-01`, `${a}-05-08`, `${a}-07-14`, `${a}-08-15`, `${a}-11-01`, `${a}-11-11`, `${a}-12-25`,
      cle(ajout(p, 1)),  // lundi de Pâques
      cle(ajout(p, 39)), // Ascension
      cle(ajout(p, 50)), // lundi de Pentecôte
    ]);
  };

  const ouvre = (d, fermes) => {
    const j = d.getDay();
    if (j === 0 || j === 6) return false;
    const k = cle(d);
    return !feries(d.getFullYear()).has(k) && !fermes.has(k);
  };

  const libelle = (cible, maintenant) => {
    const ecart = Math.round((new Date(cible.getFullYear(), cible.getMonth(), cible.getDate()) -
      new Date(maintenant.getFullYear(), maintenant.getMonth(), maintenant.getDate())) / 86400000);
    if (ecart === 1) return 'demain';
    if (ecart < 7) return JOURS[cible.getDay()];
    return `le ${JOURS[cible.getDay()]} ${cible.getDate()} ${MOIS[cible.getMonth()]}`;
  };

  const maj = () => {
    document.querySelectorAll('[data-sv-expedition]').forEach((el) => {
      const limite = parseInt(el.dataset.heureLimite || '14', 10);
      const fermes = new Set((el.dataset.joursFermes || '').split(',').map((s) => s.trim()).filter(Boolean));
      const texte = el.querySelector('[data-sv-expedition-texte]');
      if (!texte) return;
      const maintenant = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
      const reste = limite * 60 - (maintenant.getHours() * 60 + maintenant.getMinutes());
      if (ouvre(maintenant, fermes) && reste > 0) {
        const h = Math.floor(reste / 60);
        const m = reste % 60;
        const duree = h > 0 ? `${h} h ${String(m).padStart(2, '0')} min` : `${m} min`;
        texte.innerHTML = `Commandez dans <strong>${duree}</strong> : expédié <strong>aujourd'hui</strong>`;
        return;
      }
      let prochain = ajout(maintenant, 1);
      for (let n = 0; n < 30 && !ouvre(prochain, fermes); n++) prochain = ajout(prochain, 1);
      texte.innerHTML = `Commandez maintenant : expédié <strong>${libelle(prochain, maintenant)}</strong>`;
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', maj);
  else maj();
  setInterval(maj, 60000);
  // le tiroir du panier est redessiné après chaque ajout
  document.addEventListener('cart:update', () => setTimeout(maj, 50));
})();
